import axios from "axios";
const apiSafibc = axios.create({
    baseURL : 'https://api.safibc.net/safibc-api',
    //baseURL : 'http://localhost:3005/safibc-api'
})

export default apiSafibc
